<!--Checkout Button Top-->
<div class="review-main mt-40" *ngIf="cartData$ | async as cartData; else loading">
  <div class="row background-shade m-rl-0">
        <div class="col-md-9">
          <!-- <div style="float: right;padding-right: 72px;">
            <ng-container *ngIf="fastTrack == 'true'">
            <label class="quote-type label-custom pl-2" >{{ "quoteReview.quoteType" | cxTranslate }}
            <i class="material-icons quote-info" matTooltipClass="vs-tooltip" matTooltipPosition="right"
            matTooltip='{{ "quoteReview.fastTrackQuoteNote" | cxTranslate }}'>info</i>
            </label>
          <div class="vs-checkbox check-all-holder" >
            <input
              id="check-quote-type"
              type="checkbox"
              value="true"
              [checked]="true"
              name="check-quote-type"
              [disabled]="true"
            />
            <label for="check-quote-type" class="fast-track-label">{{ "quoteReview.fastTrack" | cxTranslate }}
              <span class="charges-apply">({{ "quoteReview.chargesApply" | cxTranslate }})</span></label>
          </div>
        </ng-container>
        </div> -->
        </div>
        <div class="col-md-3 text-right text-btn">
          <div class="summary-details" *ngIf="fastTrack == 'true'">
            <div class="sub-total">
              <span class="heading-text float-left">{{ "quoteReview.quoteFee" | cxTranslate }}</span>
              <span class="float-right content-bold">{{fasttrackPriceData?.price?.currencyIso}} {{fasttrackPriceData?.price.formattedValue}}</span>
            </div>
            <div class="surcharge">
              <span class="heading-text float-left" >{{ "quoteReview.surcharge" | cxTranslate }}</span>
              <span class="float-right content-bold">{{ fasttrackPriceData?.price?.currencyIso }}
                {{0 | currency: fasttrackPriceData?.price?.currencyIso :"symbol-narrow"}}</span>
            </div>
            <div class="quote-price-summary" >
              <span class="float-left">{{ "quoteReview.cartTotal" | cxTranslate }} ( {{ cartData?.totalItems }} item):</span>
              <span class="float-right">{{fasttrackPriceData?.price?.currencyIso}} {{fasttrackPriceData?.price.formattedValue}}</span>
            </div>
            <div class="quote-billable-note" >
              <span class="float-left">({{ "quoteReview.billableOnOrder" | cxTranslate }})
                <i class='material-icons' matTooltipClass="vs-tooltip" matTooltip="Message" matTooltipPosition="above">info</i>
              </span>
              <!-- <span class="float-right">USD $250.00</span> -->
            </div>
            <div class="quote-summary-actions">
              <button class="vs-primary-btn checkoutBtn" (click)="sumbitQuote()">
                {{ "quoteReview.submitQuote" | cxTranslate }}
              </button>
            </div>
          </div> 
          <p class="mb-10" *ngIf="fastTrack == 'false'">
            <span class="cart-total" *ngIf="cartData.totalItems > 1"
              >{{ "quoteReview.cartTotal" | cxTranslate }} ( {{ cartData.totalItems }} items):
            </span>

            <span class="cart-total" *ngIf="cartData.totalItems <= 1"
              >{{ "quoteReview.cartTotal" | cxTranslate }} ( {{ cartData.totalItems }} item):
            </span>
            <span class="bold"> {{ "quoteReview.toBeQuoted" | cxTranslate }} </span>
            <button class="vs-primary-btn checkoutBtn" (click)="sumbitQuote()">
              {{ "quoteReview.submitQuote" | cxTranslate }}
            </button>
          </p>
          
        </div>
  </div>
  <div class="row m-rl-0 w-95">
    <div class="col-md-12 download">
      <em class="material-icons-outlined" (click)="downloadPDF()"
      >cloud_download</em>
    <span class="download-text" (click)="downloadPDF()"
      >{{ "quoteReview.downLoadPDF" | cxTranslate }}</span>
    </div>
  </div>
  <div class="container-fluid container-review">
    <div class="row">
      <div class="section-container">
        <div class="row">
          <div class="heading-text ml-15">{{ "quoteReview.quotationDetails" | cxTranslate }}</div>
        </div>
        <hr />
        <vs-quotation-details
          [customerProjectName]="cartData.customerProjectName"
          [rfqType]="cartData.rfqType"
          [endUserIndustry]="cartData.endUserIndustry"
          [legalEntity]="cartData.legalEntity"
        ></vs-quotation-details>
      </div>
    </div>

    <div class="row">
      <div class="section-container">
        <div class="row">
          <div class="heading-text col-md-10">{{ "quoteReview.addressDetails" | cxTranslate }}</div>
          <!-- <div>
            <a [routerLink]="/rfqCart"></a>
          </div> -->
          <div class="col-md-2 text-right">
            <a class="route-link-style" (click)="routeForEditAddress()"
              >{{ "quoteReview.editAddress" | cxTranslate }}</a
            >
          </div>
        </div>
        <hr />
        <vs-address-details
          [soldToAddress]="cartData.billToAddress"
          [shipToAddress]="cartData.deliveryAddress"
          [endUserAddress]="cartData.endUserAddress"
        ></vs-address-details>
      </div>
    </div>
    <div class="row">
      <div class="section-container">
        <div class="row">
          <div class="heading-text col-md-10">{{ "quoteReview.lineItems" | cxTranslate }}</div>
          <div class="col-md-2 text-right">
            <a class="route-link-style" (click)="routeForEditCart()"
              >{{ "quoteReview.editCart" | cxTranslate }}</a
            >
          </div>
        </div>
        <hr />
        <!-- <div class="row">
          <div class="section-heading-text">
            Sold To Address
          </div>
        </div> -->

        <vs-line-items [cartData$]="cartData$"></vs-line-items>
      </div>
    </div>
    <!-- *ngIf="
    !(
      cartData?.endUserAddress?.country?.isocode === 'FR' &&
      cartData?.legalEntity === '6260'
    ) &&
    !(
      cartData?.endUserAddress?.country?.isocode === 'US' &&
      cartData?.legalEntity === '1810'
    ) &&
    !(
      cartData?.endUserAddress?.country?.isocode === 'IN' &&
      cartData?.legalEntity == '9090'
    )
  " -->
    <div class="row">
      <div class="section-container">
        <div class="row">
          <div class="heading-text">{{ "quoteReview.exportQuestionnaire" | cxTranslate }}</div>
        </div>
        <hr />

        <vs-review-compliance-question
          [complianceQuestionData]="complianceQuestionData"
          [warningFlagText]="cartData.warningFlagText"
        ></vs-review-compliance-question>
      </div>
    </div>
    <div class="row">
      <div class="section-container">
        <div class="row">
          <div class="heading-text">{{ "quoteReview.Notifications" | cxTranslate }}</div>
        </div>
        <hr />

        <vs-review-notification-attachments
          [notificationEmail]="notificationEmail"
          [contactNumber]="contactNumber"
          [attachments]="attachments"
        ></vs-review-notification-attachments>
      </div>
    </div>
    <!--Checkout Button Bottom-->
    <div class="row btn-checkout-botton">
      <div class="col-md-12">
        <div class="row mb5 m-t-20">
          <div class="col-md-9"></div>
          <div class="col-md-3 text-right text-btn">
            <p class="mb-10">
              <span class="cart-total" *ngIf="cartData.totalItems > 1"
                >{{ "quoteReview.cartTotal" | cxTranslate }} ( {{ cartData.totalItems }} items):
              </span>

              <span class="cart-total" *ngIf="cartData.totalItems <= 1"
                >{{ "quoteReview.cartTotal" | cxTranslate }} ( {{ cartData.totalItems }} item):
              </span>
              <span class="bold"> {{ "quoteReview.toBeQuoted" | cxTranslate }} </span>
              <!-- <span
                *ngIf="
                  !checkForObsoleteProducts(cartData) &&
                  cartData.totalPrice.formattedValue &&
                  isLoggedinUser &&
                  showPrice
                "
                class="content"
              >
                {{ cartData.totalPrice.currencyIso }}
                {{ cartData.totalPrice.formattedValue }}
              </span>
              <span
                *ngIf="
                  checkForObsoleteProducts(cartData) ||
                  !cartData.totalPrice.formattedValue ||
                  !isLoggedinUser ||
                  !showPrice
                "
                class="bold"
              >
                To Be Quoted
              </span> -->
            </p>
            <button class="vs-primary-btn checkoutBtn" (click)="sumbitQuote()">
              {{ "quoteReview.submitQuote" | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </div>
     
  </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
